import React from 'react'
import { Text, View, useStyles } from '@ion-ui/core'
import { useMediaQuery } from 'react-responsive'
import property from '../../assets/svg/liquidez01.svg'
import clouds from '../../assets/svg/liquidez02.svg'
import cloudLarge from '../../assets/svg/liquidez03.svg'
import percent from '../../assets/svg/liquidez04.svg'
import house from '../../assets/svg/liquidez05.svg'
import { Styles } from './styles'

const creditLine = [{
  img: property,
  title: 'Utilízalo para lo que necesites',
  description_img: 'illustration property'
},
{
  img: clouds,
  title: 'Desde $100 mil hasta $30 millones',
  description_img: 'illustration cloud'
},
{
  img: cloudLarge,
  title: 'Plazos de 5 a 20 años',
  description_img: 'illustration big dream'
},
{
  img: percent,
  title: 'Tasa del 20.25%*',
  description_img: 'illustration percent'
},
{
  img: house,
  title: 'Desde el 66% del valor de tu inmueble**',
  description_img: 'illustration house'
}]

const KnowOurCredit = () => {
  const styles = useStyles(Styles)
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' })

  return (
    <View variant='section' css={styles.sectionContainer}>
      <View variant='article' css={styles.mainStyle}>
        <View css={styles.wrapperStyle}>
          <Text variant={isMobile ? 'h5' : 'h4'} css={styles.title}
            center>
            ¿Qué es un crédito de liquidez con garantía? 
          </Text>
          <Text variant='subtitle' css={styles.subtitle}>
              Es una línea de crédito con la que podrás unificar y pagar tus deudas haciéndolas más baratas,
              también, podrás impulsar a tu negocio o incluso remodelar, dejando parte de un inmueble como garantía.
              Nuestro crédito de liquidez tiene una tasa mucho más baja que un préstamo personal o una tarjeta de crédito 
              y un plazo para pagar muy amplio.
          </Text>
        </View>
        <View css={styles.containerCards}>
          {creditLine.map((item, i) =>
            <View css={styles.cards} key={item + '_' + i}>
              <img
                src={item.img}
                alt={item.description_img}
              />
              <Text variant='h6' center>
                {item.title}
              </Text>
            </View>
          )}
        </View>
      </View>
      <Text variant='caption2' center>
        *CAT PROMEDIO 20.9% sin IVA, para fines informativos y de comparación<br />
        **Sujeto a análisis de crédito
      </Text>
    </View>
  )
}

export default KnowOurCredit
